// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"8d1cb062","78":"41e5a3a7","141":"ef063719","260":"ca62ec22","505":"9f8e1652","985":"d4001185"}[chunkId] + ".css";
};